import React from 'react';

// Contact Data
const contactItems = [
  { 
    label: "X", 
    value: "@theojeffgood", 
    link: "https://www.twitter.com/theojeffgood",
    isLink: true
  },
  { 
    label: "Github", 
    value: "theojeffgood", 
    link: "https://www.github.com/theojeffgood",
    isLink: true
  },
  { 
    label: "LinkedIn", 
    value: "/in/theo-goodman", 
    link: "https://www.linkedin.com/in/theo-goodman",
    isLink: true
  },
  { 
    label: "Email", 
    value: "theo at hellogoodman dot com", 
    link: "",
    isLink: false
  }
];

// Contact Item Component
const ContactItem: React.FC<{ 
  label: string; 
  value: string; 
  link: string;
  isLink: boolean;
}> = ({ label, value, link, isLink }) => {
  return (
    <div className="flex flex-col sm:flex-row mb-3">
      <div className="w-full sm:w-32">
        <p className="text-gray-400 text-xs">{label}</p>
      </div>
      <div className="sm:ml-6 whitespace-nowrap">
        {isLink ? (
          <a 
            href={link} 
            className="font-light text-black hover:underline text-sm" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            {value}
          </a>
        ) : (
          <p className="font-light text-black text-sm">{value}</p>
        )}
        {isLink && <span className="text-black ml-1">↗</span>}
      </div>
    </div>
  );
};

// Contact Component
const Contact: React.FC = () => {
  return (
    <div className="flex flex-col">
      {contactItems.map((item, index) => (
        <ContactItem 
          key={index} 
          label={item.label} 
          value={item.value} 
          link={item.link}
          isLink={item.isLink}
        />
      ))}
    </div>
  );
};

export default Contact; 